import { ReactNode, useEffect, useState } from 'react';
import { useSlidePanelShallowStore } from '@frontend/slide-panel';
import { getRecentCallsUniqueKey } from '../utils';
import { CallDetailsScreen } from './call-details-screen';
import { CallQualityDrilldownScreen } from './call-quality-drilldown-screen';
import { CallQualityScreen } from './call-quality-screen';
import { SCREENS } from './const';
import { CallDetailsContext, ScreenBase } from './types';

const Screens: Record<keyof typeof SCREENS, ({ setScreen }: ScreenBase) => ReactNode> = {
  [SCREENS.CALL_DETAILS]: CallDetailsScreen,
  [SCREENS.CALL_QUALITY]: CallQualityScreen,
  [SCREENS.CALL_QUALITY_DRILLDOWN]: CallQualityDrilldownScreen,
};

export const CallDetailsPanel = () => {
  const [screen, setScreen] = useState<keyof typeof SCREENS>(SCREENS.CALL_DETAILS);
  const Screen = screen ? Screens[screen] : Screens[SCREENS.CALL_DETAILS];

  const { context } = useSlidePanelShallowStore<CallDetailsContext>('setShow', 'context', 'show');
  const row = context?.rows.find((row) => row.id === context.currentRowId);
  const currentRowIndex = context?.rows.findIndex((row) => getRecentCallsUniqueKey(row) === context.currentRowId) ?? 0;

  const callDetailsUniqueKey = !!row ? getRecentCallsUniqueKey(row) : '';

  // This effect is used to scroll and highlight the selected row into view when the component mounts or when the row changes.
  useEffect(() => {
    if (row) {
      context?.toggleRowSelected?.(callDetailsUniqueKey, true);
      const rowElement = document.querySelectorAll(`#${context?.instanceId} [role=row]`)[currentRowIndex];
      rowElement?.scrollIntoView({ behavior: 'smooth' });
    }
    return () => {
      if (context && row) {
        context.toggleRowSelected?.(callDetailsUniqueKey, false);
      }
    };
  }, [row]);

  if (!context || !row) {
    return null;
  }

  return (
    <div style={{ display: 'grid', gridTemplateRows: 'auto 1fr auto', height: '100%', overflow: 'auto' }}>
      <Screen setScreen={setScreen} />
    </div>
  );
};
